import Icon from '@mdi/react';
import React from 'react';
import { FieldError } from 'react-hook-form';
import { mdiInformationOutline } from 'src/assets/icons/mdiIcons';

export const FieldErrorDisplay: React.FC<{ id: string; error: FieldError }> = ({ id, error }) => {
  return (
    <span className="pds-mt-2 pds-flex pds-items-center pds-gap-2 pds-text-error" id={id}>
      <Icon title="Error" className="pds-rotate-180" path={mdiInformationOutline} size={1} />{' '}
      {error?.message?.toString()}
    </span>
  );
};
